import React from "react";
import StaticContentPage from "../components/StaticContentPage";

export default function Privacy() {
  return (
    <StaticContentPage
      title="Privacy Policy | CryptoBag"
      description="Read the CryptoBag privacy policy covering site usage data, external content providers, and how operational or editorial requests are handled."
      canonical="https://cryptobag.net/privacy"
      eyebrow="Privacy"
      heading="Privacy Policy"
      intro="This page explains how CryptoBag handles routine site usage information, external data dependencies, and any information voluntarily provided through a contact path. It is meant to give a clear overview of how privacy works on the site."
      sections={[
        {
          title: "Information Collected",
          paragraphs: [
            "The site may process basic technical and operational data created through normal usage, including page requests, browser activity, and routine server logs. That information is used to run the platform, improve reliability, troubleshoot problems, and support normal security and maintenance work.",
          ],
        },
        {
          title: "Third-Party Data And Content",
          paragraphs: [
            "CryptoBag uses third-party providers to support pricing data, asset information, sentiment signals, and linked content across the platform. External destinations and source websites are outside CryptoBag’s control and remain governed by their own policies and practices.",
          ],
        },
        {
          title: "Use Of Information",
          paragraphs: [
            "Any information processed through routine site usage is used for operational purposes such as maintaining availability, improving reliability, diagnosing technical issues, and understanding how core parts of the site are being used. CryptoBag does not use that information to provide personalized financial advice or build trading profiles.",
          ],
        },
      ]}
    />
  );
}
